import { Reducer } from "redux";

import { NotesViewResponse } from "../models/Api/AuthorizationDetailsTab";
import { NotesViewDispatchTypes } from "../models/DispatchTypes/AuthorizationDetailstab";
import { NotesViewActionDispatchTypes } from "../constants/Authorization";

const initialState: NotesViewResponse = {
    loading: false,
    response: {
        noteEntryJson: "",
    },
    error: null,
};

const NotesViewReducer: Reducer<
    NotesViewResponse,
    NotesViewDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case NotesViewActionDispatchTypes.NOTES_VIEW_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case NotesViewActionDispatchTypes.NOTES_VIEW_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case NotesViewActionDispatchTypes.NOTES_VIEW_ERROR: {
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        }
        case NotesViewActionDispatchTypes.NOTES_VIEW_RESET: {
            return initialState;
        }
    }
    return state;
};
export default NotesViewReducer;
